import {CHALLAN_DETAILS} from "../../constant/ActionType";

export default function challanDetailReducer(state = {
    challanDetails:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case CHALLAN_DETAILS:
			return { ...state,
				challanDetails: action.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
